export interface ITaskApplicantInfo {
  id?: number | string;
  fullname?: string;
  full_name?: string;
  fullname_nat?: string;
  fullnameNat?: string;
  birth_date?: string;
  dateOfBirth?: string;
  nationality?: string;
  form_office?: string;
  office_url?: string;
  level_education?: string;
  levelEducation?: string;
  email?: string;
  phone?: string;
  preparatory_department?: string;
  certification_equalization?: string;
}

export const parseTaskNumericId = (value: unknown): number => {
  if (typeof value === "number" && Number.isFinite(value)) return value;
  if (typeof value === "string" && value.trim() !== "") {
    const parsed = Number.parseInt(value.replace(/\D+/g, ""), 10);
    if (Number.isFinite(parsed) && parsed >= 0) return parsed;
  }
  return 0;
};

export const parseTaskApplicantInfo = (value: unknown): ITaskApplicantInfo => {
  if (value == null) return {};
  if (typeof value === "object") return value as ITaskApplicantInfo;
  if (typeof value !== "string") return {};

  const trimmed = value.trim();
  if (!trimmed) return {};

  try {
    const parsed = JSON.parse(trimmed) as unknown;
    if (parsed && typeof parsed === "object") return parsed as ITaskApplicantInfo;
  } catch {
    return { fullname: trimmed };
  }

  return {};
};

export const parseTaskUserEmail = (value: unknown): string => {
  if (value == null) return "";
  if (typeof value === "string") return value.trim();

  if (typeof value !== "object") return String(value).trim();

  const record = value as Record<string, unknown>;
  const candidates = ["email", "login", "username", "name", "fullname", "full_name"];
  for (const key of candidates) {
    const candidate = record[key];
    if (typeof candidate === "string" && candidate.trim()) return candidate.trim();
  }

  return "";
};

/** Applicant id from task `applicant_info.id` (fallback: task.applicant_id). */
export const parseTaskApplicantId = (applicantInfo: ITaskApplicantInfo, fallback?: unknown): number => {
  const fromApplicantInfo = parseTaskNumericId(applicantInfo.id);
  if (fromApplicantInfo > 0) return fromApplicantInfo;
  return parseTaskNumericId(fallback);
};

export const resolveTaskApiId = (rawTask?: { id?: string | number }, taskId?: string, rowId?: number): string => {
  if (rawTask?.id != null && String(rawTask.id).trim() !== "") return String(rawTask.id).trim();
  if (taskId?.trim()) return taskId.trim();
  if (rowId != null) return String(rowId);
  return "";
};

export const parseTaskUserId = (value: unknown, fallback?: unknown): number => {
  if (value != null && typeof value === "object") {
    const record = value as Record<string, unknown>;
    const parsed = parseTaskNumericId(record.id ?? record.user_id);
    if (parsed > 0) return parsed;
  }
  return parseTaskNumericId(fallback);
};
